import { useEffect, useState } from "react";
import { useNavigate} from "react-router-dom";
import API_URL from "../config";
 
// ── Animation intro Wash Bros ──────────────────────────────────────────────
function WashBrosIntro() {
  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "linear-gradient(to bottom, #f2f2f2, #dfefff)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 9999,
      animation: "fadeOutIntro 0.6s ease 3.2s forwards",
    }}>
      <style>{`
        @keyframes fadeOutIntro { to { opacity: 0; pointer-events: none; } }
        @keyframes floatLogo { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
        @keyframes settle {
          0%{transform:scale(1) rotate(0deg)} 15%{transform:scale(1.02) rotate(-1deg)}
          30%{transform:scale(0.99) rotate(1deg)} 45%{transform:scale(1.01) rotate(-0.5deg)}
          60%,100%{transform:scale(1) rotate(0deg)}
        }
        @keyframes pulse {
          0%,100%{transform:translate(-50%,-50%) scale(1);opacity:0.7}
          50%{transform:translate(-50%,-50%) scale(1.1);opacity:1}
        }
        @keyframes rise {
          0%{transform:translateY(0) translateX(0) scale(0.9);opacity:0}
          10%{opacity:0.8} 50%{transform:translateY(-500px) translateX(25px) scale(1)}
          100%{transform:translateY(-1100px) translateX(-25px) scale(1.15);opacity:0}
        }
        .wb-bubble{position:absolute;bottom:-120px;border-radius:50%;
          background:radial-gradient(circle at 30% 30%,rgba(255,255,255,0.95),rgba(0,140,255,0.35));
          opacity:0.75;animation:rise linear infinite;backdrop-filter:blur(2px)}
        .wb-bubble::after{content:'';position:absolute;top:20%;left:25%;width:25%;height:25%;
          border-radius:50%;background:rgba(255,255,255,0.8)}
      `}</style>
      <div style={{ position: "relative", width: 500, height: 500 }}>
        <div style={{
          position: "absolute", width: 320, height: 320,
          background: "radial-gradient(circle,rgba(0,132,255,0.25),transparent 70%)",
          borderRadius: "50%", top: "50%", left: "50%",
          transform: "translate(-50%,-50%)", animation: "pulse 3s ease-in-out infinite", zIndex: 1,
        }} />
        {[
          { left:"10%", size:40, dur:"8s", delay:"0s" },
          { left:"22%", size:70, dur:"10s", delay:"1s" },
          { left:"35%", size:30, dur:"7s", delay:"2s" },
          { left:"50%", size:90, dur:"11s", delay:"0.5s" },
          { left:"68%", size:50, dur:"9s", delay:"1.5s" },
          { left:"80%", size:35, dur:"6s", delay:"3s" },
        ].map((b, i) => (
          <div key={i} className="wb-bubble" style={{
            left: b.left, width: b.size, height: b.size,
            animationDuration: b.dur, animationDelay: b.delay,
          }} />
        ))}
        <div style={{
          position: "absolute", inset: 0, display: "flex",
          alignItems: "center", justifyContent: "center",
          animation: "floatLogo 4s ease-in-out infinite", zIndex: 2,
        }}>
          <img src="/images/wash_bros_logo.png" alt="Wash Bros" style={{
            width: "75%",
            filter: "drop-shadow(0 15px 25px rgba(0,0,0,0.18))",
            animation: "settle 2.8s ease-in-out infinite",
          }} />
        </div>
      </div>
    </div>
  );
}
 
// ── QR Code avec rotation toutes les 10 secondes ───────────────────────────
function QRCodeSection({ user, navigate }) {
  const [tick, setTick] = useState(() => Math.floor(Date.now() / 10000));
  const [countdown, setCountdown] = useState(10 - (Math.floor(Date.now() / 1000) % 10));
  const [fade, setFade] = useState(true);
 
  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const newTick = Math.floor(now / 10000);
      const secondsLeft = 10 - (Math.floor(now / 1000) % 10);
      setCountdown(secondsLeft);
      if (newTick !== tick) {
        setFade(false);
        setTimeout(() => {
          setTick(newTick);
          setFade(true);
        }, 300);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tick]);
 
  // QR verrouillé si pas payé
  if (!user.washBrosPaye) {
    return (
      <div className="rounded-xl shadow-sm border p-6 text-center"
        style={{ backgroundColor: "var(--bg-card)", borderColor: "var(--border)" }}>
        <div className="text-4xl mb-3">🔒</div>
        <h3 className="font-semibold mb-2" style={{ color: "var(--text)" }}>QR Code verrouillé</h3>
        <p className="text-sm" style={{ color: "var(--text-muted)" }}>
          Votre QR code sera activé après confirmation de votre paiement en boutique.
        </p>
        <div className="mt-4 inline-flex items-center gap-2 bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-2">
          <span className="text-yellow-600 text-sm font-medium">⏳ En attente de paiement</span>
        </div>
        <button
          onClick={() => navigate("/wash-bros")}
          className="mt-4 w-full py-2.5 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition text-sm"
        >
          💳 Choisir / modifier mon abonnement
        </button>
      </div>
    );
  }
 
  // QR actif et rotatif
  const qrData = encodeURIComponent(`washbros:${user._id}:${tick}`);
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${qrData}`;
 
  return (
    <div className="rounded-xl shadow-sm border p-6 text-center"
      style={{ backgroundColor: "var(--bg-card)", borderColor: "var(--border)" }}>
      <h3 className="font-semibold mb-4" style={{ color: "var(--text)" }}>🎫 Votre QR Code</h3>
 
      <div style={{ transition: "opacity 0.3s ease", opacity: fade ? 1 : 0 }}>
        <img src={qrUrl} alt="QR Code"
          className="mx-auto rounded-lg shadow-sm mb-3"
          style={{ width: 180, height: 180 }} />
      </div>
 
      <p className="text-sm mb-3" style={{ color: "var(--text-muted)" }}>
        Présentez ce QR code en boutique à chaque passage
      </p>
 
      {/* Barre countdown */}
      <div className="w-full bg-gray-200 rounded-full h-1.5 mb-2 max-w-[180px] mx-auto overflow-hidden">
        <div className="h-1.5 rounded-full bg-blue-500"
          style={{ width: `${(countdown / 10) * 100}%`, transition: "width 0.5s linear" }} />
      </div>
      <p className="text-xs mb-3" style={{ color: "var(--text-muted)" }}>
        Nouveau code dans {countdown}s
      </p>
 
      <div className="inline-flex items-center gap-2 bg-green-50 border border-green-200 rounded-lg px-4 py-2">
        <span className="text-green-600 text-sm font-medium">✅ Actif</span>
      </div>
    </div>
  );
}
 
// ── Page principale ────────────────────────────────────────────────────────
export default function MonCompte() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showIntro, setShowIntro] = useState(true);
  const navigate = useNavigate();
 
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return navigate("/login");
    fetch(`${API_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => {
        if (!data.washBrosActif) return navigate("/wash-bros");
        setUser(data);
        setLoading(false);
      })
      .catch(() => navigate("/login"));
  }, [navigate]);
 
  useEffect(() => {
    const timer = setTimeout(() => setShowIntro(false), 3800);
    return () => clearTimeout(timer);
  }, []);
 
  if (loading) return <div className="text-center mt-20">Chargement...</div>;
 
  const passagesRestants = 10 - (user.passages % 10);
  const progression = (user.passages % 10) * 10;
 
  return (
    <>
      {showIntro && <WashBrosIntro />}
 
      <div className="min-h-screen px-4 py-10" style={{ backgroundColor: "var(--bg)" }}>
        <div className="max-w-md mx-auto space-y-6">
 
          {/* Header */}
          <div className="rounded-xl shadow-sm border p-6 text-center"
            style={{ backgroundColor: "var(--bg-card)", borderColor: "var(--border)" }}>
            <img src="/images/wash_bros_logo.png" alt="Wash Bros"
              className="w-16 h-16 object-contain mx-auto mb-3" />
            <h1 className="text-xl font-bold" style={{ color: "var(--text)" }}>
              Bonjour, {user.username} !
            </h1>
            <p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>{user.email}</p>
            <span className={`inline-block mt-2 text-xs font-medium px-3 py-1 rounded-full ${
              user.abonnement === "WashBros Mensuel"
                ? "bg-blue-100 text-blue-700"
                : "bg-gray-100 text-gray-600"
            }`}>
              {user.abonnement}
            </span>
          </div>
 
          {/* QR Code */}
          <QRCodeSection user={user} navigate={navigate} />
 
          {/* Carte fidélité */}
          <div className="rounded-xl shadow-sm border p-6"
            style={{ backgroundColor: "var(--bg-card)", borderColor: "var(--border)" }}>
            <h2 className="text-lg font-semibold mb-4" style={{ color: "var(--text)" }}>
              🧺 Carte de fidélité
            </h2>
            <div className="flex justify-between text-sm mb-2" style={{ color: "var(--text-muted)" }}>
              <span>{user.passages % 10} / 10 passages</span>
              <span>{passagesRestants} restant{passagesRestants > 1 ? "s" : ""}</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-4 mb-4">
              <div className="bg-blue-500 h-4 rounded-full transition-all"
                style={{ width: `${progression}%` }} />
            </div>
            <div className="flex justify-between mt-2">
              {Array.from({ length: 10 }).map((_, i) => (
                <div key={i} className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${
                  i < user.passages % 10 ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-400"
                }`}>
                  {i + 1}
                </div>
              ))}
            </div>
          </div>
 
          {/* Services gratuits */}
          {user.servicesGratuits > 0 && (
            <div className="bg-green-50 border border-green-200 rounded-xl p-6 text-center">
              <div className="text-3xl mb-2">🎉</div>
              <h2 className="text-lg font-semibold text-green-800">
                {user.servicesGratuits} service{user.servicesGratuits > 1 ? "s" : ""} gratuit{user.servicesGratuits > 1 ? "s" : ""} disponible{user.servicesGratuits > 1 ? "s" : ""}
              </h2>
              <p className="text-green-600 text-sm mt-1">Montre cette page au comptoir !</p>
            </div>
          )}
 
          {/* Total passages */}
          <div className="rounded-xl shadow-sm border p-6 text-center"
            style={{ backgroundColor: "var(--bg-card)", borderColor: "var(--border)" }}>
            <p className="text-sm" style={{ color: "var(--text-muted)" }}>Total de passages</p>
            <p className="text-4xl font-bold text-blue-600 mt-1">{user.passages}</p>
          </div>
 
          {/* Déconnexion */}
          <button
            onClick={() => { localStorage.clear(); navigate("/login"); }}
            className="w-full py-2.5 bg-red-50 text-red-600 font-medium rounded-lg hover:bg-red-100 transition"
          >
            Se déconnecter
          </button>
 
        </div>
      </div>
    </>
  );
}
 